/**
 * ArchiMate 3.1 Element Definitions
 */

export const ARCHIMATE_LAYERS = {
  STRATEGY: 'strategy',
  BUSINESS: 'business',
  APPLICATION: 'application',
  TECHNOLOGY: 'technology',
  PHYSICAL: 'physical',
  IMPLEMENTATION: 'implementation',
  MOTIVATION: 'motivation'
};

export const ARCHIMATE_ELEMENTS = {
  // Strategy Layer
  RESOURCE: { layer: 'strategy', type: 'resource', shape: 'rectangle', label: 'Resource' },
  CAPABILITY: { layer: 'strategy', type: 'capability', shape: 'rounded_rectangle', label: 'Capability' },
  COURSE_OF_ACTION: { layer: 'strategy', type: 'course_of_action', shape: 'rounded_rectangle', label: 'Course of Action' },
  VALUE_STREAM: { layer: 'strategy', type: 'value_stream', shape: 'rounded_rectangle', label: 'Value Stream' },

  // Business Layer
  BUSINESS_ACTOR: { layer: 'business', type: 'business_actor', shape: 'rectangle', label: 'Business Actor' },
  BUSINESS_ROLE: { layer: 'business', type: 'business_role', shape: 'rectangle', label: 'Business Role' },
  BUSINESS_COLLABORATION: { layer: 'business', type: 'business_collaboration', shape: 'rectangle', label: 'Business Collaboration' },
  BUSINESS_INTERFACE: { layer: 'business', type: 'business_interface', shape: 'rectangle', label: 'Business Interface' },
  BUSINESS_PROCESS: { layer: 'business', type: 'business_process', shape: 'rounded_rectangle', label: 'Business Process' },
  BUSINESS_FUNCTION: { layer: 'business', type: 'business_function', shape: 'rounded_rectangle', label: 'Business Function' },
  BUSINESS_INTERACTION: { layer: 'business', type: 'business_interaction', shape: 'rounded_rectangle', label: 'Business Interaction' },
  BUSINESS_EVENT: { layer: 'business', type: 'business_event', shape: 'rounded_rectangle', label: 'Business Event' },
  BUSINESS_SERVICE: { layer: 'business', type: 'business_service', shape: 'rounded_rectangle', label: 'Business Service' },
  BUSINESS_OBJECT: { layer: 'business', type: 'business_object', shape: 'rectangle', label: 'Business Object' },
  CONTRACT: { layer: 'business', type: 'contract', shape: 'rectangle', label: 'Contract' },
  REPRESENTATION: { layer: 'business', type: 'representation', shape: 'rectangle', label: 'Representation' },
  PRODUCT: { layer: 'business', type: 'product', shape: 'rectangle', label: 'Product' },

  // Application Layer
  APPLICATION_COMPONENT: { layer: 'application', type: 'application_component', shape: 'rectangle', label: 'Application Component' },
  APPLICATION_COLLABORATION: { layer: 'application', type: 'application_collaboration', shape: 'rectangle', label: 'Application Collaboration' },
  APPLICATION_INTERFACE: { layer: 'application', type: 'application_interface', shape: 'rectangle', label: 'Application Interface' },
  APPLICATION_FUNCTION: { layer: 'application', type: 'application_function', shape: 'rounded_rectangle', label: 'Application Function' },
  APPLICATION_INTERACTION: { layer: 'application', type: 'application_interaction', shape: 'rounded_rectangle', label: 'Application Interaction' },
  APPLICATION_PROCESS: { layer: 'application', type: 'application_process', shape: 'rounded_rectangle', label: 'Application Process' },
  APPLICATION_EVENT: { layer: 'application', type: 'application_event', shape: 'rounded_rectangle', label: 'Application Event' },
  APPLICATION_SERVICE: { layer: 'application', type: 'application_service', shape: 'rounded_rectangle', label: 'Application Service' },
  DATA_OBJECT: { layer: 'application', type: 'data_object', shape: 'rectangle', label: 'Data Object' },

  // Technology Layer
  NODE: { layer: 'technology', type: 'node', shape: 'cube', label: 'Node' },
  DEVICE: { layer: 'technology', type: 'device', shape: 'cube', label: 'Device' },
  SYSTEM_SOFTWARE: { layer: 'technology', type: 'system_software', shape: 'rectangle', label: 'System Software' },
  TECHNOLOGY_COLLABORATION: { layer: 'technology', type: 'technology_collaboration', shape: 'rectangle', label: 'Technology Collaboration' },
  TECHNOLOGY_INTERFACE: { layer: 'technology', type: 'technology_interface', shape: 'rectangle', label: 'Technology Interface' },
  TECHNOLOGY_FUNCTION: { layer: 'technology', type: 'technology_function', shape: 'rounded_rectangle', label: 'Technology Function' },
  TECHNOLOGY_PROCESS: { layer: 'technology', type: 'technology_process', shape: 'rounded_rectangle', label: 'Technology Process' },
  TECHNOLOGY_SERVICE: { layer: 'technology', type: 'technology_service', shape: 'rounded_rectangle', label: 'Technology Service' },
  ARTIFACT: { layer: 'technology', type: 'artifact', shape: 'rectangle', label: 'Artifact' },

  // Physical Layer
  EQUIPMENT: { layer: 'physical', type: 'equipment', shape: 'cube', label: 'Equipment' },
  FACILITY: { layer: 'physical', type: 'facility', shape: 'cube', label: 'Facility' },
  MATERIAL: { layer: 'physical', type: 'material', shape: 'rectangle', label: 'Material' },

  // Implementation Layer
  WORK_PACKAGE: { layer: 'implementation', type: 'work_package', shape: 'rounded_rectangle', label: 'Work Package' },
  DELIVERABLE: { layer: 'implementation', type: 'deliverable', shape: 'rectangle', label: 'Deliverable' },
  PLATEAU: { layer: 'implementation', type: 'plateau', shape: 'rectangle', label: 'Plateau' },
  GAP: { layer: 'implementation', type: 'gap', shape: 'rectangle', label: 'Gap' },

  // Motivation Layer
  STAKEHOLDER: { layer: 'motivation', type: 'stakeholder', shape: 'rectangle', label: 'Stakeholder' },
  DRIVER: { layer: 'motivation', type: 'driver', shape: 'rectangle', label: 'Driver' },
  ASSESSMENT: { layer: 'motivation', type: 'assessment', shape: 'rectangle', label: 'Assessment' },
  GOAL: { layer: 'motivation', type: 'goal', shape: 'rounded_rectangle', label: 'Goal' },
  OUTCOME: { layer: 'motivation', type: 'outcome', shape: 'rounded_rectangle', label: 'Outcome' },
  PRINCIPLE: { layer: 'motivation', type: 'principle', shape: 'rectangle', label: 'Principle' },
  REQUIREMENT: { layer: 'motivation', type: 'requirement', shape: 'rectangle', label: 'Requirement' },
  CONSTRAINT: { layer: 'motivation', type: 'constraint', shape: 'rectangle', label: 'Constraint' },
  VALUE: { layer: 'motivation', type: 'value', shape: 'ellipse', label: 'Value' }
};

export const ARCHIMATE_COLORS = {
  strategy: { fill: '#F5DEAA', stroke: '#C9A348', strokeWidth: 2, text: '#000' },
  business: { fill: '#FFFFB5', stroke: '#C9C93A', strokeWidth: 2, text: '#000' },
  application: { fill: '#B5FFFF', stroke: '#34B6B6', strokeWidth: 2, text: '#000' },
  technology: { fill: '#C9E7B7', stroke: '#6EAA5E', strokeWidth: 2, text: '#000' },
  physical: { fill: '#C9E7B7', stroke: '#6EAA5E', strokeWidth: 2, text: '#000' },
  implementation: { fill: '#FFE0C7', stroke: '#D89F6A', strokeWidth: 2, text: '#000' },
  motivation: { fill: '#CCCCFF', stroke: '#8080FF', strokeWidth: 2, text: '#000' },
  other: { fill: '#E0E0E0', stroke: '#808080', strokeWidth: 2, text: '#000' }
};

export const getArchimateColors = (layer) => ARCHIMATE_COLORS[layer] || ARCHIMATE_COLORS.other;

export const ARCHIMATE_RELATIONSHIPS = {
  COMPOSITION: { type: 'composition', style: 'solid', startCap: 'none', endCap: 'filled_diamond', label: 'Composition' },
  AGGREGATION: { type: 'aggregation', style: 'solid', startCap: 'none', endCap: 'diamond', label: 'Aggregation' },
  ASSIGNMENT: { type: 'assignment', style: 'solid', startCap: 'filled_circle', endCap: 'arrow', label: 'Assignment' },
  REALIZATION: { type: 'realization', style: 'dashed', startCap: 'none', endCap: 'triangle', label: 'Realization' },
  SERVING: { type: 'serving', style: 'solid', startCap: 'none', endCap: 'arrow', label: 'Serving' },
  ACCESS: { type: 'access', style: 'dashed', startCap: 'none', endCap: 'arrow', label: 'Access' },
  INFLUENCE: { type: 'influence', style: 'dashed', startCap: 'none', endCap: 'arrow', label: 'Influence' },
  TRIGGERING: { type: 'triggering', style: 'solid', startCap: 'none', endCap: 'filled_arrow', label: 'Triggering' },
  FLOW: { type: 'flow', style: 'dashed', startCap: 'none', endCap: 'filled_arrow', label: 'Flow' },
  SPECIALIZATION: { type: 'specialization', style: 'solid', startCap: 'none', endCap: 'triangle', label: 'Specialization' },
  ASSOCIATION: { type: 'association', style: 'solid', startCap: 'none', endCap: 'none', label: 'Association' }
};

export const getArchimateRelationship = (type) => ARCHIMATE_RELATIONSHIPS[type] || ARCHIMATE_RELATIONSHIPS.ASSOCIATION;

export const getElementsByLayer = (layer) => {
  return Object.entries(ARCHIMATE_ELEMENTS)
    .filter(([_, def]) => def.layer === layer)
    .map(([key, def]) => ({ key, ...def }));
};
